// extracted by css-extract-rspack-plugin
export default {"slideUpWrapper":"SlideUpConsumer-SlideUpWrapper-slideUpWrapper-6268ea81"};